import rates from './rates.json';
import { HoldingPeriod } from '../common/constants';
import { calculateTaxAmountForRate, safeDivide, BASE_TAX_CALCULATION_RESULT } from '../common/utils';

export const calculateFederalTaxAmount = ({ gainAmount, annualIncome, holdingPeriod, fillingStatus }) => {
  return rates.federal[holdingPeriod][fillingStatus].reduce((result, bracket) => calculateTaxAmountForRate({
    currentResult: result,
    amount: gainAmount,
    adjustment: annualIncome,
    bracket
  }), BASE_TAX_CALCULATION_RESULT);
}

export const calculateStateTaxAmount = ({ gainAmount, annualIncome, fillingStatus, state }) => {
  return rates.state[state][fillingStatus].reduce((result, bracket) => calculateTaxAmountForRate({
    currentResult: result,
    amount: gainAmount,
    adjustment: annualIncome,
    bracket
  }), BASE_TAX_CALCULATION_RESULT);
}

export const calculateCombinedFederalTaxAmount = ({ shortTermGainsAmount, longTermGainsAmount, annualIncome, fillingStatus }) => {
  const shortTermResult = calculateFederalTaxAmount({
    gainAmount: shortTermGainsAmount,
    annualIncome: annualIncome,
    fillingStatus: fillingStatus,
    holdingPeriod: HoldingPeriod.ShortTerm
  });

  const longTermResult = calculateFederalTaxAmount({
    gainAmount: longTermGainsAmount,
    annualIncome: annualIncome + shortTermGainsAmount,
    fillingStatus: fillingStatus,
    holdingPeriod: HoldingPeriod.LongTerm
  });

  const totalGains = shortTermGainsAmount + longTermGainsAmount;
  const totalTaxAmount = shortTermResult.amount + longTermResult.amount;

  return {
    amount: totalTaxAmount,
    marginalRate: longTermResult.marginalRate,
    effectiveRate: safeDivide(totalTaxAmount, totalGains) * 100
  };
}
